export default "https://cdn-static.gokick.com/assets/3c8eadbe8dc90fc8bfe5d2560afe7db765946837/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";